<template>
  <div
      class="content-page page"
  >
    <AppPageLoader :collection="pageCollection" :filter="pageFilter" @loaded="onPageLoaded">
      <div
          class="page__inner"
      >
        <AppContentHero
            v-if="state.data"
            :title="state.data.title"
            :image="state.data?.image"
            class="content-page__content-hero"
        />
        <div
            v-if="state.data"
        >
          <AppRichTextBlock v-if="state.data.introduction" :data="{text:state.data.introduction}"/>
          <AppDynamicBlock
              :is="useBlock(block)"
              v-for="block in state.data.content"
              :key="`block_${block.id}`"
              :data="block"
          />

          <ClientOnly>
            <LayoutsShare v-if="state.data?.share"/>
          </ClientOnly>
        </div>
      </div>
    </AppPageLoader>
    <AppAnimatedTitle/>
    <LayoutsFooter class="content-page__footer"/>
  </div>
</template>

<script setup lang="ts">
/*
    this dynamic page lives at multiple routes (content pages in the root,
    and in the content-[group] directory
*/
import {reactive} from 'vue'
import {useRoute} from 'nuxt/app'
import {useBlock} from '#imports'
import {TContentPage} from '~/types/page-types'
import {AppContentHero, AppPageLoader} from '#components'

const pageCollection = 'content_page'
const route = useRoute()

type TState = {
  data?: TContentPage,
};

const state: TState = reactive({
  data: undefined
})

const pageFilter = {
  status: 'published',
  belongs_to: {}
}

if (route.params.group) {
  pageFilter.belongs_to = {
    slug: {
      _eq: route.params.group
    }
  }
} else {
  // an empty group (/content-/<slug>/) is redirected by the middleware in pages/[...slug].vue
  // search within content pages without a content_group
  pageFilter.belongs_to = {
    _null: true
  }
}

const onPageLoaded = (data) => {
  state.data = data

  const publishedDate = data?.date_created ? new Date(data?.date_created).toISOString().split('T')[0] : undefined;
  const revisionDate = data?.date_revisioned ? new Date(data?.date_revisioned).toISOString().split('T')[0] : undefined;

  useJsonld({
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: data.title,
    datePublished: publishedDate,
    dateModified: revisionDate,
    author: {
      '@type': 'Organization',
      name: 'AVROTROS'
    },
  })
}

</script>

<style scoped lang="postcss">
.content-page {
  display: flex;
  min-height: 100dvh;
  flex-direction: column;

  &__content-hero {
    @mixin app-show-hero;
  }

  &__footer {
    margin-top: auto;
  }
}
</style>
